import { useState } from "react";
import { Mail, ArrowRight } from "lucide-react";
import { useLang } from "../lib/LanguageContext";
import { api } from "../lib/api";
import { toast } from "sonner";

export default function Newsletter({ variant = "default" }) {
    const { t, lang } = useLang();
    const [email, setEmail] = useState("");
    const [busy, setBusy] = useState(false);
    const [done, setDone] = useState(false);

    const submit = async (e) => {
        e.preventDefault();
        if (!email) return;
        setBusy(true);
        try {
            await api.post("/newsletter", { email });
            setDone(true);
            setEmail("");
            toast.success(
                lang === "al"
                    ? "Faleminderit! Do t'ju dërgojmë ofertat tona të reja."
                    : "Thank you! You'll receive our latest offers.",
            );
        } catch {
            toast.error(
                lang === "al" ? "Pati një gabim. Provoni përsëri." : "Something went wrong.",
            );
        } finally {
            setBusy(false);
        }
    };

    if (variant === "footer") {
        return (
            <form onSubmit={submit} className="flex gap-2" data-testid="newsletter-footer">
                <input
                    type="email"
                    required
                    placeholder={lang === "al" ? "Email-i juaj" : "Your email"}
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    data-testid="newsletter-footer-email"
                    className="flex-1 bg-white/10 border border-white/20 text-white placeholder-white/50 rounded-full px-4 py-2 text-sm focus:outline-none focus:border-white/60"
                />
                <button
                    type="submit"
                    disabled={busy || done}
                    data-testid="newsletter-footer-submit"
                    className="bg-[#CBA871] hover:bg-[#b8945e] text-[#0F3A59] px-4 py-2 rounded-full text-sm font-medium transition disabled:opacity-50"
                >
                    {done ? "✓" : busy ? "..." : (lang === "al" ? "Regjistrohu" : "Subscribe")}
                </button>
            </form>
        );
    }

    return (
        <section className="py-20 md:py-28 px-6 md:px-12 bg-[#F4EFE6]" data-testid="newsletter-section">
            <div className="max-w-3xl mx-auto text-center">
                <div className="inline-flex items-center justify-center w-14 h-14 rounded-full bg-white mb-6">
                    <Mail size={22} strokeWidth={1.5} className="text-[#0F3A59]" />
                </div>
                <h2 className="font-serif text-3xl md:text-4xl tracking-tight text-[#0F3A59]">
                    {lang === "al" ? "Mos i humb ofertat tona" : "Don't miss our offers"}
                </h2>
                <p className="text-[#1C1C1C]/70 font-light mt-4 max-w-xl mx-auto">
                    {lang === "al"
                        ? "Regjistrohu për të marrë ofertat speciale dhe lajmet më të reja nga Kompleksi Dea Radhimë."
                        : "Subscribe to receive special offers and the latest news from Kompleksi Dea Radhimë."}
                </p>
                <form
                    onSubmit={submit}
                    className="mt-8 flex flex-col sm:flex-row gap-3 max-w-md mx-auto"
                    data-testid="newsletter-form"
                >
                    <input
                        type="email"
                        required
                        placeholder={lang === "al" ? "Email-i juaj" : "Your email"}
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        data-testid="newsletter-email"
                        className="flex-1 bg-white border border-[#E5E0D8] rounded-full px-5 py-3 focus:outline-none focus:border-[#0F3A59]"
                    />
                    <button
                        type="submit"
                        disabled={busy || done}
                        data-testid="newsletter-submit"
                        className="bg-[#0F3A59] hover:bg-[#1C5279] text-white px-7 py-3 rounded-full text-sm font-medium tracking-wide flex items-center justify-center gap-2 disabled:opacity-50"
                    >
                        {done
                            ? lang === "al" ? "U regjistrove ✓" : "Subscribed ✓"
                            : busy
                              ? "..."
                              : lang === "al"
                                ? "Regjistrohu"
                                : "Subscribe"}
                        {!done && !busy && <ArrowRight size={16} />}
                    </button>
                </form>
            </div>
        </section>
    );
}
